import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONFIG_URLS_API } from '../../environments/config-envs';
import { environment } from '../../environments/environment';
import { LocalStorageService } from './localstorage.service';

export interface IBaseRetorno {
  sucesso: boolean;
  mensagens: string[];
}
export interface IPostoMacroPosto {
  codPosto: number;
  nomePosto: string;
}

export interface IMacroPostoResponse extends IBaseRetorno {
  retorno: IPostoMacroPosto[];
}

@Injectable({
  providedIn: 'root',
})
export class MacroPostoServicesService {
  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageService);
  private usuarioMacroPosto = false;
  private userGuid: string = '';

  constructor() {
    const usuario = JSON.parse(this.localStorageService.getItem('userData'));
    console.log('Dados do usuário no serviço MacroPosto:', usuario);
    if (usuario && usuario.retorno) {
      this.usuarioMacroPosto = usuario.retorno.tipo === 8;
      this.userGuid = usuario.retorno.guid || '';
    }
  }

  public listarPostosMacroPostoAsync(): Observable<IMacroPostoResponse> {
    console.log('User GUID no serviço MacroPosto:', this.userGuid);

    var httoptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Userguid: this.userGuid,
      }),
    };

    return this.http.post<IMacroPostoResponse>(
      `${environment.host_ctf_service}${CONFIG_URLS_API.API_PegarPostosListaAcordo}`,
      null,
      httoptions
    );
  }

  public usuarioEhMacroPosto(): boolean {
    return this.usuarioMacroPosto;
  }
}
